import * as _ from 'lodash';
import { Injectable } from '@angular/core';
import { ServiceInsightsRequests } from 'src/app/core/services/service-insights-requests';
import { AddedServiceMetric, ServiceInsightsTableRow,ServiceInsightsPresentationData,ServiceInsightsPresentationDataObject, ServiceInsightsTable, ServiceInsightsCallData, SITotalCallsByType, topBottomLocationRow, ServiceInsightsByPeriodData, ExpandedPhotosResult, ByLocationMetrics, ServiceInsightsByLocationData, ByIssueMetrics, ServiceInsightsByIssueData, ExpandedPhotosByGroupKey, PestServiceInsightsCallData, PestTotalCallsByTypeData, SICallTypes, SICallTypesDisplayName, ServiceMetricTypes, SICallTypesDatabaseCode, ExpandedPhotosMap, ServiceInsightsObsByLocationData, ServiceInsightsObservationsData, ServiceInsightsMetricCountsSummary } from '../types/service-insight-types';
import { AlertService } from 'src/app/core/services/alert.service';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { FiltersService } from 'src/app/core/services/filters.service';
import { Guid } from 'guid-typescript';
import { MetricDetailsRequest } from 'src/app/global/metric-details';
import { ServiceCustomerFilterOptions, ServiceCustomerFilters } from 'src/app/global/service-customer-model';

@Injectable({
  providedIn: 'root'
})
export class ServiceInsightsService {
  public isServiceInsightsLoaded: boolean = false;

  //#region Subscriptions

  //#region SI Calls By Period
  public emptyServiceInsightsByPeriodData: ServiceInsightsByPeriodData ={
    percentChangeInCount: 0,
    periods: [],
    distinctLocationsCount: 0
  };

  private serviceInsightsCallData: ServiceInsightsCallData = {
    [SICallTypes.ExtraServiceVisit] : new BehaviorSubject<ServiceInsightsByPeriodData>(this.emptyServiceInsightsByPeriodData),
    [SICallTypes.RegularServiceCalls] : new BehaviorSubject<ServiceInsightsByPeriodData>(this.emptyServiceInsightsByPeriodData),
    [SICallTypes.ProgramReviews]: new BehaviorSubject<ServiceInsightsByPeriodData>(this.emptyServiceInsightsByPeriodData),
    [SICallTypes.Installations]: new BehaviorSubject<ServiceInsightsByPeriodData>(this.emptyServiceInsightsByPeriodData),
    [SICallTypes.TrainingSessions]: new BehaviorSubject<ServiceInsightsByPeriodData>(this.emptyServiceInsightsByPeriodData),
    [SICallTypes.QuickCalls]: new BehaviorSubject<ServiceInsightsByPeriodData>(this.emptyServiceInsightsByPeriodData),
    [SICallTypes.TotalCalls]: new BehaviorSubject<ServiceInsightsByPeriodData>(this.emptyServiceInsightsByPeriodData),
    // Only for QSR/ FRS
    [SICallTypes.Audit]: new BehaviorSubject<ServiceInsightsByPeriodData>(this.emptyServiceInsightsByPeriodData)
  };

  private pestServiceInsightsCallData: PestServiceInsightsCallData = {
    [SICallTypes.ContractedCleanOut] : new BehaviorSubject<ServiceInsightsByPeriodData>(this.emptyServiceInsightsByPeriodData),
    [SICallTypes.ContractedRegular] : new BehaviorSubject<ServiceInsightsByPeriodData>(this.emptyServiceInsightsByPeriodData),
    [SICallTypes.ExtraOneShot]: new BehaviorSubject<ServiceInsightsByPeriodData>(this.emptyServiceInsightsByPeriodData),
    [SICallTypes.ExtraFollowUp]: new BehaviorSubject<ServiceInsightsByPeriodData>(this.emptyServiceInsightsByPeriodData),
    "Services-total-calls": new BehaviorSubject<ServiceInsightsByPeriodData>(this.emptyServiceInsightsByPeriodData),
    "Findings-total-calls": new BehaviorSubject<ServiceInsightsByPeriodData>(this.emptyServiceInsightsByPeriodData),
    [SICallTypes.Pest]:new BehaviorSubject<ServiceInsightsByPeriodData>(this.emptyServiceInsightsByPeriodData),
    [SICallTypes.Sanitation]:new BehaviorSubject<ServiceInsightsByPeriodData>(this.emptyServiceInsightsByPeriodData),
    [SICallTypes.Structural]:new BehaviorSubject<ServiceInsightsByPeriodData>(this.emptyServiceInsightsByPeriodData),
    [SICallTypes.Prep]:new BehaviorSubject<ServiceInsightsByPeriodData>(this.emptyServiceInsightsByPeriodData),
    "CallsByReason-total-calls": new BehaviorSubject<ServiceInsightsByPeriodData>(this.emptyServiceInsightsByPeriodData),
    [SICallTypes.ExtraServiceRequest]: new BehaviorSubject<ServiceInsightsByPeriodData>(this.emptyServiceInsightsByPeriodData)
  };


  setServiceInsightsCallData(key: keyof ServiceInsightsCallData, data: ServiceInsightsByPeriodData) {
    this.serviceInsightsCallData[key].next(data);
  }

  getServiceInsightsCallData(key: keyof ServiceInsightsCallData): BehaviorSubject<ServiceInsightsByPeriodData> {
    return this.serviceInsightsCallData[key];
  }

  setPestServiceInsightsCallData(key: keyof PestServiceInsightsCallData, data: ServiceInsightsByPeriodData) {
    this.pestServiceInsightsCallData[key].next(data);
  }

  getPestServiceInsightsCallData(key: keyof PestServiceInsightsCallData): BehaviorSubject<ServiceInsightsByPeriodData> {
    return this.pestServiceInsightsCallData[key];
  }
  //#endregion

  //#region SI Calls By Location
  public emptyByLocationMetrics: ByLocationMetrics[] =[];

  private serviceInsightsLocationData: ServiceInsightsByLocationData = {
    [SICallTypes.ExtraServiceVisit] : new BehaviorSubject<ByLocationMetrics[]>(this.emptyByLocationMetrics),
    [SICallTypes.RegularServiceCalls] : new BehaviorSubject<ByLocationMetrics[]>(this.emptyByLocationMetrics),
    [SICallTypes.ProgramReviews]: new BehaviorSubject<ByLocationMetrics[]>(this.emptyByLocationMetrics),
    [SICallTypes.Installations]: new BehaviorSubject<ByLocationMetrics[]>(this.emptyByLocationMetrics),
    [SICallTypes.TrainingSessions]: new BehaviorSubject<ByLocationMetrics[]>(this.emptyByLocationMetrics),
    [SICallTypes.QuickCalls]: new BehaviorSubject<ByLocationMetrics[]>(this.emptyByLocationMetrics),
    [SICallTypes.VirtualAssistCalls]: new BehaviorSubject<ByLocationMetrics[]>(this.emptyByLocationMetrics),
    [SICallTypes.TotalCalls]: new BehaviorSubject<ByLocationMetrics[]>(this.emptyByLocationMetrics),
    // Only for QSR/ FRS
    [SICallTypes.Audit]: new BehaviorSubject<ByLocationMetrics[]>(this.emptyByLocationMetrics)
  };

  setServiceInsightsLocationData(key: keyof ServiceInsightsByLocationData, data: ByLocationMetrics[]) {
    this.serviceInsightsLocationData[key].next(data);
  }

  getServiceInsightsLocationData(key: keyof ServiceInsightsByLocationData): BehaviorSubject<ByLocationMetrics[]> {
    return this.serviceInsightsLocationData[key];
  }

  resetServiceInsightsCallData() {
    this.serviceInsightsCallData= {
      [SICallTypes.ExtraServiceVisit] : new BehaviorSubject<ServiceInsightsByPeriodData>(this.emptyServiceInsightsByPeriodData),
      [SICallTypes.RegularServiceCalls] : new BehaviorSubject<ServiceInsightsByPeriodData>(this.emptyServiceInsightsByPeriodData),
      [SICallTypes.ProgramReviews]: new BehaviorSubject<ServiceInsightsByPeriodData>(this.emptyServiceInsightsByPeriodData),
      [SICallTypes.Installations]: new BehaviorSubject<ServiceInsightsByPeriodData>(this.emptyServiceInsightsByPeriodData),
      [SICallTypes.TrainingSessions]: new BehaviorSubject<ServiceInsightsByPeriodData>(this.emptyServiceInsightsByPeriodData),
      [SICallTypes.QuickCalls]: new BehaviorSubject<ServiceInsightsByPeriodData>(this.emptyServiceInsightsByPeriodData),
      [SICallTypes.TotalCalls]: new BehaviorSubject<ServiceInsightsByPeriodData>(this.emptyServiceInsightsByPeriodData),
      [SICallTypes.Audit]: new BehaviorSubject<ServiceInsightsByPeriodData>(this.emptyServiceInsightsByPeriodData)
    };
  }
  //#endregion

  //#region SI Calls By Issues
  public emptyByIssuesMetrics: ByIssueMetrics[] =[];

  private serviceInsightsByIssuesData: ServiceInsightsByIssueData = {
    [SICallTypes.ExtraServiceVisit] : new BehaviorSubject<ByIssueMetrics[]>(this.emptyByIssuesMetrics),
    [SICallTypes.RegularServiceCalls] : new BehaviorSubject<ByIssueMetrics[]>(this.emptyByIssuesMetrics),
    [SICallTypes.ProgramReviews]: new BehaviorSubject<ByIssueMetrics[]>(this.emptyByIssuesMetrics),
    [SICallTypes.Installations]: new BehaviorSubject<ByIssueMetrics[]>(this.emptyByIssuesMetrics),
    [SICallTypes.TrainingSessions]: new BehaviorSubject<ByIssueMetrics[]>(this.emptyByIssuesMetrics),
    [SICallTypes.QuickCalls]: new BehaviorSubject<ByIssueMetrics[]>(this.emptyByIssuesMetrics),
    [SICallTypes.VirtualAssistCalls]: new BehaviorSubject<ByIssueMetrics[]>(this.emptyByIssuesMetrics),
    [SICallTypes.TotalCalls]: new BehaviorSubject<ByIssueMetrics[]>(this.emptyByIssuesMetrics),
    // Only for QSR/ FRS
    [SICallTypes.Audit]: new BehaviorSubject<ByIssueMetrics[]>(this.emptyByIssuesMetrics),
  };

  setServiceInsightsByIssuesData(key: keyof ServiceInsightsByIssueData, data: ByIssueMetrics[]) {
    this.serviceInsightsByIssuesData[key].next(data);
  }

  getServiceInsightsByIssuesData(key: keyof ServiceInsightsByIssueData): BehaviorSubject<ByIssueMetrics[]> {
    return this.serviceInsightsByIssuesData[key];
  }
  //#endregion

  //#region SI Obs By Period
  private serviceInsightsObsData : ServiceInsightsObservationsData = {
    [SICallTypes.VirtualAssistCalls]: new BehaviorSubject<ServiceInsightsByPeriodData>(this.emptyServiceInsightsByPeriodData),
    [SICallTypes.PhotoObservations] : new BehaviorSubject<ServiceInsightsByPeriodData>(this.emptyServiceInsightsByPeriodData)
  };

  setServiceInsightsObsData(key: keyof ServiceInsightsObservationsData, data: ServiceInsightsByPeriodData) {
    this.serviceInsightsObsData[key].next(data);
  }
  getServiceInsightsObsData(key: keyof ServiceInsightsObservationsData): BehaviorSubject<ServiceInsightsByPeriodData> {
    return this.serviceInsightsObsData[key];
  }
  //#endregion  

  //#region SI Total Calls By Type
  public emptyTotalCallsByTypeData: SITotalCallsByType = {
      totalCalls : []
  }

  private totalCallsByTypeData : BehaviorSubject<SITotalCallsByType> = new BehaviorSubject<SITotalCallsByType>(this.emptyTotalCallsByTypeData);

  setTotalCallsByTypeData(data: SITotalCallsByType) {
    this.totalCallsByTypeData.next(data);
  }
  getTotalCallsByTypeData(): BehaviorSubject<SITotalCallsByType> {
    return this.totalCallsByTypeData;
  }

  //PEST Sections - Service metrics services, findings and calls
  private pestTotalCallsByTypeData : PestTotalCallsByTypeData = {
    "Services-total-calls": new BehaviorSubject<SITotalCallsByType>(this.emptyTotalCallsByTypeData),
    "Findings-total-calls": new BehaviorSubject<SITotalCallsByType>(this.emptyTotalCallsByTypeData),
    "CallsByReason-total-calls": new BehaviorSubject<SITotalCallsByType>(this.emptyTotalCallsByTypeData)
  };

  setPestTotalCallsByTypeData(key: keyof PestTotalCallsByTypeData, data: SITotalCallsByType) {
    this.pestTotalCallsByTypeData[key].next(data);
  }

  getPestTotalCallsByTypeData(key: keyof PestTotalCallsByTypeData): BehaviorSubject<SITotalCallsByType> {
    return this.pestTotalCallsByTypeData[key];
  }


  //#endregion

  //#region Expanded Photos
  public emptyExpandedPhotos: { [id:number] : ExpandedPhotosResult } = {0 : { count: 0, totalCount: 0, photos: [] }}

  public readonly expandedPhotosByGroup: Record<ExpandedPhotosByGroupKey, BehaviorSubject<ExpandedPhotosMap>> = {
    endDate: this.createExpandedPhotosSubject(),
    location: this.createExpandedPhotosSubject(),
    issue: this.createExpandedPhotosSubject(),
  };

  setExpandedPhotosByGroup(key: ExpandedPhotosByGroupKey, index: number, expandedData: ExpandedPhotosResult): void {
    const subject = this.expandedPhotosByGroup[key];
    const current = subject.getValue();

    subject.next({
      ...current,
      [index]: expandedData,
    });
  }

  getExpandedPhotosByGroup(key: ExpandedPhotosByGroupKey): BehaviorSubject<{ [id:number] : ExpandedPhotosResult }> {
      return this.expandedPhotosByGroup[key];
  }
  getExpandedPhotosByGroupX(key: ExpandedPhotosByGroupKey): Observable<ExpandedPhotosMap> {
    return this.expandedPhotosByGroup[key].asObservable();
  }

  clearAllExpandedPhotos(): void {
    for (const key of Object.keys(this.expandedPhotosByGroup) as ExpandedPhotosByGroupKey[]) {
      this.expandedPhotosByGroup[key].next({ ...this.emptyExpandedPhotos });
    }
  }

  private createExpandedPhotosSubject(): BehaviorSubject<ExpandedPhotosMap> {
    return new BehaviorSubject<ExpandedPhotosMap>({ ...this.emptyExpandedPhotos });
  }
  //#endregion

  //#region top bottom table
  private locationsTopBottomData : BehaviorSubject<topBottomLocationRow[]> = new BehaviorSubject<topBottomLocationRow[]>([])

  setLocationsTopBottomData(data: topBottomLocationRow[]) {
    this.locationsTopBottomData.next(data);
  }
  getLocationsTopBottomData(): BehaviorSubject<topBottomLocationRow[]>{
    return this.locationsTopBottomData;
  }
  //#endregion

  //#region service details advance filters

  public serviceCustomerFilters = new BehaviorSubject<ServiceCustomerFilterOptions>({
    "accountNumber": [],
    "accountName": [],
    "country": [],
    "state": [],
    "city": [],
    "zipCode": [],
    "recurringIssue": [],
  });

  clearServiceCustomerFilters() {
    this.serviceCustomerFilters.next({
      "accountNumber": [],
      "accountName": [],
      "country": [],
      "state": [],
      "city": [],
      "zipCode": [],
      "recurringIssue": [],
    });
  }

  setServiceCustomerFilters(serviceCustomerFilters:ServiceCustomerFilterOptions) {
    this.serviceCustomerFilters.next(serviceCustomerFilters);
  }

  getServiceCustomerFilters(): Observable<ServiceCustomerFilterOptions> {
    return this.serviceCustomerFilters.asObservable();
  }
  //#endregion

  //#endregion

  private addedMetricMap : Map<string, AddedServiceMetric> = new Map();
  private allSelected$ : BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  private unSelect$ : BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public isUnSelect : Observable<boolean> = this.unSelect$.asObservable();
  public isAllSelected: Observable<boolean> = this.allSelected$.asObservable();
  private totalMetrics = 7; //total # of available service metrics.
  // TODO: Use metric type enums instead of strings
  private pestMetricsMap: Map<string, boolean> = new Map([
    ['Pest', true],
    ['Sanitation', true],
    ['Structural', true],
    ['Prep', true],
    ['Pest ESR', true],
    ['Service Visits', true],
    ['Locations Serviced', true],
    ['Pest Catches', false],
  ]);
  private pestMetricsSelected$ : BehaviorSubject<Map<string, boolean>> = new BehaviorSubject<Map<string, boolean>>(this.pestMetricsMap);
  public isPestMetricsSelected : Observable<Map<string, boolean>> = this.pestMetricsSelected$.asObservable();
  private _isPestCatchesSelected: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public isPestCatchesSelected$ : Observable<boolean> = this._isPestCatchesSelected.asObservable();

  private topBottomLocationPptState : Record<string, boolean> = {
    bottomFive: false,
    bottomTen: false,
    topFive: false,
    topTen: false,
    bottomFivePercent: false,
    bottomTenPercent: false,
    topFivePercent: false,
    topTenPercent: false
  };

  tableData: ServiceInsightsTable = {
    overall: <ServiceInsightsTableRow[]>[],
    issues: <ServiceInsightsTableRow[]>[],
    recurring: <ServiceInsightsTableRow[]>[],
  };

  private serviceInsightsPptData : ServiceInsightsPresentationData = {
    "addedOverallFindings": <ServiceInsightsPresentationDataObject[]> [],
    "addedIssuesFindings": <ServiceInsightsPresentationDataObject[]> [],
    "addedRecurringIssuesFindings": <ServiceInsightsPresentationDataObject[]> []
  };

  private readonly addedTopBottomLocationsKeyMap : Map<string, string> = new Map([
    ['bottom5', 'bottomFive'],
    ['top5', 'topFive'],
    ['bottom10', 'bottomTen'],
    ['top10', 'topTen'],
    ['bottom5%', 'bottomFivePercent'],
    ['top5%', 'topFivePercent'],
    ['bottom10%', 'bottomTenPercent'],
    ['top10%', 'topTenPercent']
  ]);

  private serviceCallCodeToName : Record<string, string> = {
    [SICallTypesDatabaseCode.ExtraServiceVisit]: SICallTypesDisplayName[SICallTypes.ExtraServiceVisit],
    [SICallTypesDatabaseCode.TrainingSessions]: SICallTypesDisplayName[SICallTypes.TrainingSessions],
    [SICallTypesDatabaseCode.QuickCalls]: SICallTypesDisplayName[SICallTypes.QuickCalls],
    [SICallTypesDatabaseCode.ProgramReviews]: SICallTypesDisplayName[SICallTypes.ProgramReviews],
    [SICallTypesDatabaseCode.RegularServiceCalls]: SICallTypesDisplayName[SICallTypes.RegularServiceCalls],
    [SICallTypesDatabaseCode.Installations]: SICallTypesDisplayName[SICallTypes.Installations],
    [SICallTypesDatabaseCode.Audit]: SICallTypesDisplayName[SICallTypes.Audit],
    OTHER: 'Other',
  }

  //Maps callReason property in api response to their display name
  private PestServiceCallsCodeToName : Record<string, string> = {
    [SICallTypesDatabaseCode.ContractedCleanOut]: SICallTypesDisplayName[SICallTypes.ContractedCleanOut],
    [SICallTypesDatabaseCode.ExtraOneShot]: SICallTypesDisplayName[SICallTypes.ExtraOneShot],
    [SICallTypesDatabaseCode.ContractedRegular]: SICallTypesDisplayName[SICallTypes.ContractedRegular],
    [SICallTypesDatabaseCode.ExtraFollowUp]: SICallTypesDisplayName[SICallTypes.ExtraFollowUp],
    [SICallTypesDatabaseCode.Pest]: SICallTypesDisplayName[SICallTypes.Pest],
    [SICallTypesDatabaseCode.Sanitation]: SICallTypesDisplayName[SICallTypes.Sanitation],
    [SICallTypesDatabaseCode.Structural]: SICallTypesDisplayName[SICallTypes.Structural],
    [SICallTypesDatabaseCode.Prep]: SICallTypesDisplayName[SICallTypes.Prep],
    'PEST ESR': SICallTypesDisplayName[SICallTypes.ExtraServiceRequest],
    'NON-PEST ESR': "Non-Pest ESR",
    'SCHEDULED SVC REMINDER': 'Scheduled SVC Reminder',
    'PLEASE CALL': 'Please Call',
    'NO SHOW/NO RESPONSE': 'No Show/No Response',
    'INFORMATION': 'Information',
    'ALL OTHER': 'All Other',
  }

  constructor(
    private _siService: ServiceInsightsRequests,
    private _alertService : AlertService,
    private _filtersService: FiltersService,
  ) {
    this._filtersService.filtersConfirmed.subscribe(f => this.resetAddedServiceMetrics());
  }

  isServiceInsightsByPeriodDataEmpty (data:ServiceInsightsByPeriodData ) { return data.periods.length === 0 }

  //Get the display name for Inst Service Metrics
  public getServiceCallByCode(code : string) : string {
    return this.serviceCallCodeToName[code];
  }

  //Get the display names for Pest Service Metrics
  public getPestServiceCallByCode(code : string) : string {
    return this.PestServiceCallsCodeToName[code];
  }

  public async getTopBottomLocationInsights() {
    return await this._siService.getTopBottomLocationInsights().then(response => {
      const { data } = response;
      if (data != undefined) {
        return data;
      }
      }).catch(error => {
        console.log(JSON.stringify(error));
        this._alertService.addAlert({
          message: 'Retrieving Location Insights data failed. If problem persists, please report a bug.',
          id: Math.random() * 25
        })
      });
  }

  public async getSIMetricByPeriodFromAPI(
    metricType: ServiceMetricTypes,
    metricObsType: SICallTypes,
    serviceCustomerFilters: ServiceCustomerFilterOptions) {
    return await this._siService.getSIMetricByPeriod(metricType, metricObsType, serviceCustomerFilters).then(response => {
      // if response status is 204, then data is empty
      if (response.status === 204) return this.emptyServiceInsightsByPeriodData;
      const { data } = response;
      if (data != undefined) return data;
      throw new Error('Data is undefined');
    }).catch(error => {
      console.log(JSON.stringify(error));
      this._alertService.addAlert({
        message: `Retrieving Service Insights Metrics By Period data failed. If problem persists, please report a bug.`,
        id: Math.random() * 25
      })
    });
  }

  public async getSIMetricByLocationFromAPI(
    metricType: ServiceMetricTypes,
    metricObsType: SICallTypes,
    serviceCustomerFilters: ServiceCustomerFilterOptions) {
    return await this._siService.getSIMetricByLocationFromAPI(metricType, metricObsType, serviceCustomerFilters).then(response => {
      const { data } = response;
      if (data != undefined) {
        return data;
      }
    }).catch(error => {
      console.log(JSON.stringify(error));
      this._alertService.addAlert({
        message: `Retrieving Service Insights Metrics By Location data failed. If problem persists, please report a bug.`,
        id: Math.random() * 25
      })
    });
  }

  public async getSIMetricByIssuesFromAPI(
    metricType: ServiceMetricTypes,
    metricObsType: SICallTypes,
    serviceCustomerFilters: ServiceCustomerFilterOptions
    ) {
      return await this._siService.getSIMetricByIssuesFromAPI(metricType, metricObsType, serviceCustomerFilters).then(response => {
      const { data } = response;
      if (data != undefined) {
        return data;
      }
    }).catch(error => {
      console.log(JSON.stringify(error));
      this._alertService.addAlert({
        message: `Retrieving Service Insights Metrics By Issue data failed. If problem persists, please report a bug.`,
        id: Math.random() * 25
      })
    });
  }

  public async getTotalCallsByTypeFromAPI(metricType:ServiceMetricTypes, serviceCustomerFilters: ServiceCustomerFilterOptions){
    return await this._siService.getSITotalCallsByType(metricType, serviceCustomerFilters).then(response => {
      const { data } = response;
      if (data != undefined) {
        return data;
      }
    }).catch(error => {
      console.log(JSON.stringify(error));
      this._alertService.addAlert({
        message: `Retrieving Service Insights Total Calls By Type data failed. If problem persists, please report a bug.`,
        id: Math.random() * 25
      })
    });
  }

  // TODO: getSIMetricByPeriodFromAPI/getTotalCallsByTypeFromAPI could be migrated to this summary endpoint,
  // but are still used by Pest and the drilldown page.
  public async getMetricCountsSummaryFromAPI(): Promise<ServiceInsightsMetricCountsSummary | undefined> {
    return await this._siService.getSIMetricCountsSummary().then(response => {
      const { data } = response;
      return data as ServiceInsightsMetricCountsSummary | undefined;
    }).catch(error => {
      console.error(JSON.stringify(error));
      this._alertService.addAlert({
        message: 'Retrieving Service Insights metric summary failed. If problem persists, please report a bug.',
        id: Math.random() * 25
      });
      return undefined;
    });
  }

  async getSIExpandedPhotosFromAPI(
    payload : {
      callType:SICallTypes,
      groupType:string,
      serviceCustomerFilters: ServiceCustomerFilterOptions,
      limit:number,
      page:number }) : Promise<ExpandedPhotosResult>  {
    return await this._siService.getSIExpandedPhotos(payload).then(response => {
      const { data } = response;
      if (data != undefined) {
        return data;
      }
    }).catch(error => {
      this._alertService.addAlert({
        message: `Retrieving Service Insights Photos failed. If problem persists, please report a bug.`,
        id: Math.random() * 25
      })
    });
  }

  public async getServiceInsights(issueType: string) {
    return await this._siService.getServiceInsights( issueType).then(response => {
      const { data } = response;
      if (data != undefined) {
        return data;
      }
    }).catch(error => {
      console.log(JSON.stringify(error));
      this._alertService.addAlert({
        message: `Retrieving Service Insights data for issue type ${issueType} failed. If problem persists, please report a bug.`,
        id: Math.random() * 25
      })
    });
  }

  public async updateServiceInsightsPresentationData(updateType:string, add:boolean, issueType:string, value: ServiceInsightsTableRow[]){
    if (updateType == "single") {
      if (add) {
        this.addServiceInsightToPresentationObject(issueType, value[0]);
      } else{
        this.removeServiceInsightToPresentationObject(issueType, value[0]);
      }
    } else {
      if (add) {
        this.addAllServiceInsightToPresentationObject(issueType, value);
      } else {
        this.removeAllServiceInsightToPresentationObject(issueType);
      }
    }
  }

  private async addServiceInsightToPresentationObject(issueType:string, value:ServiceInsightsTableRow){
    let object : ServiceInsightsPresentationDataObject = {
      "Finding": value.observationName,
      "Implications": value.implications,
      "NextSteps": value.nextSteps
    };

    switch(issueType){
      case "overall":
        if (!this.serviceInsightsPptData.addedOverallFindings.some(obj => (_.isEqual(obj,object)))){
          this.serviceInsightsPptData.addedOverallFindings.push(object);
        }
        break;
      case "issues":
        if (!this.serviceInsightsPptData.addedIssuesFindings.some(obj => (_.isEqual(obj,object)))){
          this.serviceInsightsPptData.addedIssuesFindings.push(object);
        }
        break;
      case "recurring":
        if (!this.serviceInsightsPptData.addedRecurringIssuesFindings.some(obj => (_.isEqual(obj,object)))){
          this.serviceInsightsPptData.addedRecurringIssuesFindings.push(object);
        }
        break;
    }
  }

  private async removeServiceInsightToPresentationObject(issueType:string, value:ServiceInsightsTableRow){
    let object : ServiceInsightsPresentationDataObject = {
      "Finding": value.observationName,
      "Implications": value.implications,
      "NextSteps": value.nextSteps
    };
    switch (issueType) {
      case "overall":
        this.serviceInsightsPptData.addedOverallFindings = this.serviceInsightsPptData.addedOverallFindings.filter(obj => !(_.isEqual(obj,object)));
        break;
      case "issues":
        this.serviceInsightsPptData.addedIssuesFindings = this.serviceInsightsPptData.addedIssuesFindings.filter(obj => !(_.isEqual(obj,object)));
        break;
      case "recurring":
        this.serviceInsightsPptData.addedRecurringIssuesFindings = this.serviceInsightsPptData.addedRecurringIssuesFindings.filter(obj => !(_.isEqual(obj,object)));
        break;
    }
  }

  private async addAllServiceInsightToPresentationObject(issueType:string, values:ServiceInsightsTableRow[]){

    let objects : ServiceInsightsPresentationDataObject[] = values.map(obj => {
      return {
        "Finding": obj.observationName,
        "Implications": obj.implications,
        "NextSteps": obj.nextSteps
      }
    })

    switch(issueType){
      case "overall":
        this.serviceInsightsPptData.addedOverallFindings = objects;
        break;
      case "issues":
        this.serviceInsightsPptData.addedIssuesFindings = objects;
        break;
      case "recurring":
        this.serviceInsightsPptData.addedRecurringIssuesFindings = objects;
        break;
    }
  }

  private async removeAllServiceInsightToPresentationObject(issueType:string){
    switch(issueType){
      case "overall":
        this.serviceInsightsPptData.addedOverallFindings = [];
        break;
      case "issues":
        this.serviceInsightsPptData.addedIssuesFindings = [];
        break;
      case "recurring":
        this.serviceInsightsPptData.addedRecurringIssuesFindings = [];
        break;
    }
  }

  // adding and removing the service metrics charts from the presentation
  public addMetricToPresentation(metricName: string, metricValue: number) {
    this.addedMetricMap.set(metricName, {
      metricDataName: metricName,
      metricDataValue: '' + metricValue //convert metric value to string
    });

    if (this.addedMetricMap.size === this.totalMetrics) {
      this.unSelect$.next(false);
    }
  }

  public removeMetricFromPresentation(metricName: string) {
    this.addedMetricMap.delete(metricName);
    this.unSelect$.next(true);
  }

  public setPestMetricsSelected(metricName: string,checked:boolean) {
    if (this.pestMetricsMap.has(metricName)) {
    this.pestMetricsMap.set(metricName, checked);
    }
    this.pestMetricsSelected$.next(this.pestMetricsMap);
  }

  public affectAllMetricsToPresentation(checked : boolean) {
    this.allSelected$.next(checked); //emits change from clicking the 'add all' checkbox
  }

  public updateIsPestCatchesSelected(checked: boolean) {
    this._isPestCatchesSelected.next(checked);
  }

  public changeTopBottomLocsInPresentation(tab : string, selectedOption: string, added: boolean) {
    let itemPair = tab + selectedOption;
    if (this.addedTopBottomLocationsKeyMap.has(itemPair)) {
      let selectedItem = this.addedTopBottomLocationsKeyMap?.get(itemPair) as string;
      this.topBottomLocationPptState[selectedItem] = added;
    }
  }

  // returns list of service metrics that are added to the presentation currently. to be used by _constructpresentationdata in ebr.service.ts
  public getAddedServiceMetrics() {
    if (!this.isServiceInsightsLoaded) {
      ['Total Calls', 'Photo Observations', 'Extra Service Visits', 'Program Reviews', 'Training Sessions', 'Regular Service Calls', 'Installations', 'Quick Calls'].forEach((val:string, index:number) => {
        this.addMetricToPresentation(val, 0);
      });
    }
    return Array.from(this.addedMetricMap.values());
  }

  public getPestServiceMetrics() {
    if (!this.isServiceInsightsLoaded) {
      // Pest Catches is excluded from defaults — it is opt-in (defaulted to unchecked)
      ['Locations Serviced','Pest Findings','Service Visits','Sanitation Findings','Structural Findings','Pest ESRs','Prep Findings'].forEach((val:string, index:number) => {
        this.addMetricToPresentation(val, 0);
      });
    }
   return Array.from(this.addedMetricMap.values());
  }

  public getAddedTopBottomLocs() {
    return this.topBottomLocationPptState;
  }

  public getServiceInsightsDataForPresentation() {
    return this.serviceInsightsPptData;
  }

  public resetAddedServiceMetrics() {
    this.addedMetricMap.clear();
    this.allSelected$.next(false);
    this.unSelect$.next(true);
    this.pestMetricsSelected$.next(this.pestMetricsMap);
    this._isPestCatchesSelected.next(false);
  }

  public resetAllServices() {
    this.tableData = {
      overall: <ServiceInsightsTableRow[]>[],
      issues: <ServiceInsightsTableRow[]>[],
      recurring: <ServiceInsightsTableRow[]>[],
    };
    this.updateServiceInsightsPresentationData('all', false, 'overall', []);
    this.updateServiceInsightsPresentationData('all', false, 'issues', []);
    this.updateServiceInsightsPresentationData('all', false, 'recurring', []);

    Object.keys(this.serviceInsightsCallData).forEach((key) => {
      const metricType = key as keyof ServiceInsightsCallData;
      this.setServiceInsightsCallData(metricType, this.emptyServiceInsightsByPeriodData);
    });

    Object.keys(this.pestServiceInsightsCallData).forEach((key) => {
      const metricType = key as keyof PestServiceInsightsCallData;
      this.setPestServiceInsightsCallData(metricType, this.emptyServiceInsightsByPeriodData);
    });

    Object.keys(this.pestTotalCallsByTypeData).forEach((key) => {
      const metricType = key as keyof PestTotalCallsByTypeData;
      this.setPestTotalCallsByTypeData(metricType, this.emptyTotalCallsByTypeData);
    });

    Object.keys(this.serviceInsightsLocationData).forEach((key) => {
      const metricType = key as keyof ServiceInsightsByLocationData;
      this.setServiceInsightsLocationData(metricType, this.emptyByLocationMetrics);
    });

    Object.keys(this.serviceInsightsByIssuesData).forEach((key) => {
      const metricType = key as keyof ServiceInsightsByIssueData;
      this.setServiceInsightsByIssuesData(metricType, this.emptyByIssuesMetrics);
    });

    Object.keys(this.serviceInsightsObsData).forEach((key) => {
      const metricType = key as keyof ServiceInsightsObservationsData;
      this.setServiceInsightsObsData(metricType, this.emptyServiceInsightsByPeriodData);
    });
    
    this.setTotalCallsByTypeData(this.emptyTotalCallsByTypeData);
    this.setLocationsTopBottomData([]);
    this.isServiceInsightsLoaded = false;
  }

  async getServiceInsightsAdvFilters(callType?: SICallTypes): Promise<ServiceCustomerFilters[]> {
    return this._siService.getServiceDetailsAdvFilters(callType).then(response => {
      const { data } = response;
        return data as ServiceCustomerFilters[];
      }).catch(error => {
        this._handleError('Retrieving Service Details Advanced Filters failed.', error);
        return [];
      });
  }


  async getSIExpandedMetricDetails(request: MetricDetailsRequest) {
    return await this._siService.getSIExpandedMetricDetails(request);
  }

  async getServiceDetailsKpiData(serviceMetricType: SICallTypes) {
    return this._siService.getServiceDetailsKpiData(serviceMetricType).then(response => {
      const { data } = response;
      return data;
    }).catch(error => {
      this._handleError('Retrieving Service Details KPI Data failed.', error);
      return null;
    });
  }


  private _handleError(errorMessage: string, error: any) {
    console.log(errorMessage + ' : '  + JSON.stringify(error));
    this._alertService.addAlert({
      message: `${errorMessage} If problem persists, please report a bug.`,
      id: Guid.create()
    });
  }
}
